import * as React from 'react';

import styles from './styles.module.css';

export const SuggestModalMobile = React.forwardRef<HTMLUListElement, React.PropsWithChildren<{}>>((props, ref) => {
  return (
    <ul ref={ref} role="listbox" className={styles['list']} data-testid="suggest-modal-mobile">
      {props.children}
    </ul>
  );
});

SuggestModalMobile.displayName = 'SuggestModalMobile';
